import { DaciExtService } from './daciExt.service';
import { AfterContentInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { DaciExtDTO } from './daciExtDTO';
import { ConfirmationService, MenuItem } from 'primeng-lts/api';
import { TranslateService } from '@ngx-translate/core';
import { DaciExtEditionComponent } from './daciExt.edition.component';
import { UIService } from '../../ui.service';


@Component({
  selector: 'daciExt',
  templateUrl: 'daciExt.template.html',
  providers: [DialogService]
})
export class DaciExtComponent extends BaseComponent implements OnInit, OnDestroy, AfterContentInit {

  // load finalizado
  public loaded: boolean;

  // dacis existentes
  public dacis: DaciExtDTO[] = [];


  // expediente al que se encunetran asociados los dacis
  @Input()
  public dossierID: string;

  constructor(
    public dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private translationService: TranslateService,
    protected daciService: DaciExtService,
    public uiService: UIService,
  ) {
    super();


  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterContentInit(): void {

    this.loadDaciExts();

  }

  loadDaciExts() {
    this.subscribe(this.daciService.query(this.dossierID),
      (result) => {
        if (result && result.content) {
          this.dacis = result.content;
          this.loaded = true;
          console.log('Dacis:', this.dacis);

          // Obtener las descripciones después de cargar los datos
          this.dacis.forEach((daci) => {
            const description = this.getDescriptionState(daci);
            daci.descriptionI18 = description;
          });
        } else {
          this.dacis = [];
        }
      }
    );
  }



  ngOnInit() {
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public loadModal(readOnly: boolean, id?: string) {
    let config: DynamicDialogConfig = {
      header: this.translationService.instant('DaciExt.edition.title'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'
    };

    if (id != null) {
      config['id'] = id;
    }

    config['dossierID'] = this.dossierID;
    config['readOnly'] = readOnly;

    const ref = this.dialogService.open(
      DaciExtEditionComponent,
      config
    );

    this.subscribe(ref.onClose, result => {
      this.loadDaciExts();
    });

  }

  add(): void {
    this.loadModal(false);
  }

  public modify(daci: DaciExtDTO) {
    this.loadModal(false, daci.identifier);
  }

  public view(daci: DaciExtDTO) {
    this.loadModal(true, daci.identifier);
  }

  public delete(daci: DaciExtDTO) {
    this.confirmationService.confirm({
      message: this.translationService.instant('General.confirm.action.delete'),
      accept: () => {
        this.subscribe(this.daciService.remove(daci),
          (result: any) => {
            this.loadDaciExts();
          },
          err => {
            console.log('Error AL ANULAR daci', err);
            let message = 'Ha ocurrido un error al intentar anular la solicitud DACI';
            if (err?.error?.errors[0]?.validationCode) {
              message = this.translationService.instant('DaciExt.VALIDATIONCODE.' + err?.error?.errors[0]?.validationCode);
            }

            this.uiService.showMessage(message
            );
          }
        );
      }
    });
  }


  getDescriptionState(daci: DaciExtDTO): string {
    switch (daci?.state?.state?.identifier?.split('<>')[0]) {
      case '1':

        let description = '';
        if (daci.rejectionReason != null) {
          description = daci.rejectionReason;
        } else {
          description = daci.state.state.description;
        }

        const maxLength = 50; // Número máximo de caracteres permitidos
        if (description.length > maxLength) {
          description = description.substring(0, maxLength) + '...'; // Truncar el texto y agregar puntos suspensivos
        }
        return description;
      case '2':
        return this.translationService.instant('DaciExt.stateSolicitud.sign');
      default:
        return this.translationService.instant('DaciExt.stateSolicitud.pending');
    }
  }



  public getMenuItem(daciExt: DaciExtDTO): MenuItem[] {
    let items: MenuItem[] = [];

    let mn1 = {} as MenuItem;
    this.subscribe(
      this.translationService.get('General.view'),
      (res: string) => {
        mn1.label = res;
      }
    );
    mn1.icon = 'fas fa-eye';
    mn1.command = (event: Event) => {
      this.view(daciExt);
    };
    items.push(mn1);

    let mn2 = {} as MenuItem;
    this.subscribe(
      this.translationService.get('General.edit'),
      (res: string) => {
        mn2.label = res;
      }
    );
    mn2.icon = 'fas fa-pencil-alt';
    mn2.command = (event: Event) => {
      this.modify(daciExt);
    };
    items.push(mn2);

    let mn3 = {} as MenuItem;
    this.subscribe(
      this.translationService.get('General.delete'),
      (res: string) => {
        mn3.label = res;
      }
    );
    mn3.icon = 'fas fa-times';
    mn3.command = (event: Event) => {
      this.delete(daciExt);
    };
    items.push(mn3);

    return items;
  }
}
